export default __webpack_public_path__ + "static/media/collapse-menu-icon.233a6163.svg";